import { gql, useLazyQuery } from "@apollo/client";
import { AsyncQueryStatus } from "../../models/AsyncActionStatus";
import { getErrors } from "../../utils";
import {
  GetAdminRolesByOrganizationId,
  GetAdminRolesByOrganizationIdVariables,
} from "./__generated__/GetAdminRolesByOrganizationId";
import { PERMISSION_FIELDS } from "../fragments/Permission";

export const GET_ADMIN_ROLES_BY_ORGANIZATION_ID = gql`
  ${PERMISSION_FIELDS}
  query GetAdminRolesByOrganizationId($organizationId: String!) {
    adminRolesByOrganizationId(organizationId: $organizationId) {
      id
      name
      permissions {
        ...PermissionFields
      }
    }
  }
`;

export function useLazyGetAdminRolesByOrganizationId() {
  const [getAdminRolesByOrganizationId, { loading, error, data }] = useLazyQuery<
    GetAdminRolesByOrganizationId,
    GetAdminRolesByOrganizationIdVariables
  >(GET_ADMIN_ROLES_BY_ORGANIZATION_ID, {
    errorPolicy: "all",
  });

  return {
    getAdminRolesByOrganizationId,
    data,
    status: {
      loading,
      errors: getErrors(error),
      successful: !error && data ? true : false,
    } as AsyncQueryStatus,
  };
}
